import Stories from "./Stories";
import Posts from "./Posts";

export default function Feed() {
    return(
        <>
        <Stories />
        <Posts />
        </>
    );
}